"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var NotificationModel = /** @class */ (function () {
    function NotificationModel(visible) {
        this.visible = visible;
    }
    NotificationModel.prototype.onHide = function () {
        this.visible = false;
        if (this.timeoutId) {
            clearTimeout(this.timeoutId);
            this.timeoutId = undefined;
        }
    };
    NotificationModel.prototype.show = function () {
        var _this = this;
        if (this.visible) {
            return;
        }
        this.visible = true;
        this.timeoutId = setTimeout(function () {
            _this.visible = false;
            _this.timeoutId = undefined;
        }, 3500);
    };
    return NotificationModel;
}());
exports.NotificationModel = NotificationModel;
//# sourceMappingURL=notification-model.js.map